import * as actions from '../actions';
import { State } from '../types';

type Handler<A extends keyof typeof actions> = (
  state: State,
  action: ReturnType<(typeof actions)[A]>,
) => State;

export const switchMode: Handler<'switchMode'> = (state, action) => {
  const mode = action.payload;

  return {
    ...state,
    mode,
  };
};
